import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { z } from 'zod';
import { authApi } from '@/api';
import { MODULE_HUB_PATH, ORG_SIGN_IN_PATH } from '@/constants/authRoutes';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { useState } from 'react';
import { showApiError } from '@/utils/apiError';
import { notify } from '@/core/toast/notify';
import { fattahProjectTitle } from '@/config/brand';

const schema = z.object({
  email: z.string().email(),
});

type FormData = z.infer<typeof schema>;

export function ForgotPasswordPage() {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm<FormData>({
    resolver: zodResolver(schema),
  });

  const onSubmit = async (data: FormData) => {
    setLoading(true);
    try {
      await authApi.forgotPassword(data);
      setSent(true);
      notify.success('Check your email for reset instructions');
    } catch (err) {
      showApiError(err, 'Request failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card p-8">
      <h2 className="text-2xl font-bold text-center">{fattahProjectTitle('Forgot password')}</h2>
      {sent ? (
        <p className="mt-4 text-sm text-slate-600 dark:text-slate-400">
          If the email exists, a reset link was sent. Check your inbox.
        </p>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)} className="mt-6 space-y-4">
          <Input label="Email" type="email" {...register('email')} error={errors.email?.message} />
          <Button type="submit" className="w-full" loading={loading}>
            Send reset link
          </Button>
        </form>
      )}
      <Link to={MODULE_HUB_PATH} className="mt-4 inline-block text-sm text-primary-600 hover:underline">
        Back to home
      </Link>
      {' · '}
      <Link to={ORG_SIGN_IN_PATH} className="text-sm text-primary-600 hover:underline">
        Organization sign in
      </Link>
    </div>
  );
}
